import React from 'react';
import SwipeSlider from '@wix/da-shared-react/pkg/SwipeSlider.v2';
import { withTranslation, WithTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import { Url, URLS } from '@wix/da-url';
import { MeasuredSlider as Slider } from '@wix/da-shared-react/pkg/Slider';
import DuperbrowseContext from '../../../../../contexts/DuperbrowseContext';
import AddItemCard from '../../_partials/AddItemCard';
import WidgetBox, {
  Props as WidgetBoxProps,
} from '../../../../UserWidgets/_partials/WidgetBox';
import { ShopItemType } from '../../../../../../types/shop';
import ShopThumb, {
  ShopThumbType,
  PANEL_HEIGHT,
} from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Shop';
import EmptyState from '../../_partials/EmptyState';
import { withMobileContext } from '@wix/da-react-context/pkg/MobileContext';
import withFeatureFlags, {
  WithFeatureFlagsProps,
} from '@wix/da-react-context/pkg/flags/withFeatureFlags';

export interface Props {
  streamId: string;
  moduleId: number;
  dasDeviations: PapiDeviation[];
  total: number;
  isOwner: boolean;
  username: string;
  isMobile?: boolean;
  isPaywalUpdates?: boolean;
}

export class DasSlider extends React.Component<
  Props & WidgetBoxProps & WithTranslation & WithFeatureFlagsProps
> {
  render() {
    const {
      isMobile,
      isOwner,
      isPaywalUpdates,
      streamId,
      t,
      widgetMoveUp,
      widgetMoveDown,
      widgetRemove,
      moduleId,
      dasDeviations,
      total,
      username,
      section,
      zone,
      flags,
    } = this.props;

    if (!flags.includes('digital_assets')) {
      return null;
    }

    const isEmpty = !dasDeviations.length;

    return (
      <WidgetBox
        section={section}
        zone={zone}
        header={'Digital Assets'}
        count={total}
        moduleId={moduleId}
        widgetMoveUp={widgetMoveUp}
        widgetMoveDown={widgetMoveDown}
        widgetRemove={widgetRemove}
        isEmpty={isEmpty}
        hasMore={!isEmpty} // until we implement inner slider overflow recognition
        emptyView={<EmptyState view="wide" shopItemType={ShopItemType.DAS} />}
        seeAllUrl={Url.userShopPath(username, 'digital_assets' as any)}
        headerClassName={this.props.headerClassName}
      >
        <DuperbrowseContext
          streamId={streamId}
          deviations={dasDeviations}
          parent={{ title: t('duperbrowse.backButton.profile.shop') }}
        >
          {isMobile ? (
            <SwipeSlider>
              {dasDeviations.map(deviation => (
                <ShopThumb
                  key={deviation.deviationId}
                  deviation={deviation}
                  type={ShopThumbType.DAS}
                  showAuthor={false}
                />
              ))}
            </SwipeSlider>
          ) : (
            <Slider
              renderSliderItems={elementSize => (
                <>
                  {isPaywalUpdates && isOwner ? (
                    <AddItemCard
                      title={t('pages.shop.premiumFolders.addItem.title')}
                      subtitle={t('pages.shop.premiumFolders.addItem.subtitle')}
                      onClick={() => window.location.replace(URLS.SUBMIT)}
                    />
                  ) : null}
                  {dasDeviations.map(deviation => (
                    <ShopThumb
                      key={deviation.deviationId}
                      deviation={deviation}
                      width={elementSize.width}
                      height={elementSize.height + PANEL_HEIGHT}
                      type={ShopThumbType.DAS}
                      showAuthor={false}
                    />
                  ))}
                </>
              )}
            />
          )}
        </DuperbrowseContext>
      </WidgetBox>
    );
  }
}

export default withFeatureFlags(
  withMobileContext(withTranslation()(DasSlider))
);
